// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__31BAQ","row":"Option_row__1vVem"};